<div class="btn-group {{isInsideModal ? 'is-inside-modal' : ''}}" dropdown #dropdown="bs-dropdown" [container]="container" [isDisabled]="disabled">
  @if (status != 'Invoiced' && !isClient) {
    <div id="button-basic" (click)="toggleStatus($event)" type="button" controls="dropdown-basic">
      <span class="cursor-pointer nav-font14 text-nowrap nav-status-selected {{statusClass}}" [class.open]="dropdown.isOpen" [class.cursor-default]="isClientUser">
        @if(showIcons){
          <i class="fak fa-{{statusClass}} font-weight-bold"></i>
        }
        {{ status }}
        @if (!isClientUser && !disabled) {
          <i class="fak fa-down-arrow fa-xs"></i>
        }
      </span>
    </div>
  }
  @if (status == 'Invoiced' || isClient) {
    <div type="button" controls="dropdown-basic">
      <span class="cursor-pointer nav-font14 text-nowrap nav-status {{statusClass}}">
        @if(showIcons){
          <i class="fak fa-{{statusClass}} font-weight-bold"></i>
        }
        {{ status }}
      </span>
    </div>
  }
    <ul id="dropdown-status" *dropdownMenu class="dropdown-menu dropdown-menu-right clickable" [class.position-relative]="isPositionRelative" role="menu" aria-labelledby="button-basic">
      <span  (mouseleave)="onMouseLeave(dropdown)">
        @for (value of _values; track value; let idx = $index) {
      <li role="menuitem" class="expandable status-item" [class.closed]="closed" [class.border-bottom-0]="(idx+1) === _values?.length">
        <a class="dropdown-item cursor-pointer nav-status" (click)="applyStatus(value?.status)">
          @if(showIcons){
            <i class="fak fa-{{value?.class }} font-weight-bold mr-2"></i>
          }
          {{ value?.status }}
        </a>
      </li>
      }
      @if (partnerId == null) {
      <div class="px-3 mt-2 expandable clickable" [class.closed]="!closed">
        <small class="mb-2 d-block clickable">You have changed this Project's status to <span class="font-weight-bold">{{ status }}</span></small>
        <small class="d-block clickable">Would you also like to update all Vendors status for this project?</small>
        <div class="float-right py-2 px-1 clickable">
          <button class="small-button btn nav-btn-primary btn-sm shadow-none mx-1 clickable" type="button" (click)="toggleStatus($event)"><i class="fa fa-times mt-1"></i></button>
          <button class="small-button btn nav-btn-accent btn-sm shadow-none clickable" type="button" (click)="applyStatusPartners($event)"><i class="fa fa-check mt-1"></i></button>
        </div>
      </div>
      }

      </span>
    </ul>
</div>

<ng-template #invoiceConfirm>
  <div class="modal-header">
    <p class="h5">Confirm Invoice</p>
  </div>
  <div class="modal-body text-center">
    <p class="h6">Are you sure you want to change project status to invoiced? Once a project is Invoiced the status can no longer be changed.</p>
    <button type="button" class="btn nav-btn-primary btn-sm shadow-none mx-1" (click)="openModalRef.hide()">No</button>
    <button type="button" class="btn nav-btn-accent btn-sm shadow-none" (click)="newStatusValue = 'Invoiced'; updateToNonLiveStatus()">Yes</button>
  </div>
</ng-template>

